import React from 'react';

export const SeoBanner = ({ title, description, photo }) => (
  <div className="offers-seo-banner-wrapper">
    <div className="seo-banner" style={{ backgroundImage: `url( ${photo} )` }}>
      <article className="banner-description">
        <h1 className="region-title">{title}</h1>
        <span className="hyphen" />
        <div
          className="region-description"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </article>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./app/javascript/pages/offers/components/SeoBanner.jsx